import { twJoin } from 'tailwind-merge';

export const LAYOUT_CONTAINER_CLASS = twJoin('mx-auto max-w-screen-xl px-4');
export const LAYOUT_GRID_CLASS = twJoin('grid grid-cols-[1fr_280px_min(100%,600px)_1fr]');
export const SCROLLBAR_VISIBLE_CLASS = twJoin('overflow-y-scroll [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-grey-300 dark:[&::-webkit-scrollbar-thumb]:bg-grey-700 [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-1.5');
